import { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const IconUsersThree: FC<IProps> = ({
  width = 24,
  height = 24,
  color = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.875C14.0711 16.875 15.75 15.1961 15.75 13.125C15.75 11.0539 14.0711 9.375 12 9.375C9.92893 9.375 8.25 11.0539 8.25 13.125C8.25 15.1961 9.92893 16.875 12 16.875Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 10.875C19.2485 10.8735 20.1103 11.0762 20.8916 11.4669C21.6729 11.8575 22.3521 12.4253 22.875 13.125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.125 13.125C1.64794 12.4253 2.32714 11.8575 3.10843 11.4669C3.88972 11.0762 4.75149 10.8735 5.625 10.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.59961 20.2496C7.09351 19.2381 7.86156 18.3856 8.81628 17.7894C9.77099 17.1931 10.874 16.877 11.9996 16.877C13.1252 16.877 14.2282 17.1931 15.1829 17.7894C16.1377 18.3856 16.9057 19.2381 17.3996 20.2496"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.62414 10.875C5.05474 10.8756 4.49694 10.7141 4.0159 10.4094C3.53487 10.1048 3.15047 9.6695 2.90763 9.15449C2.66478 8.63947 2.57352 8.06598 2.6445 7.50102C2.71548 6.93607 2.94577 6.40298 3.30847 5.96404C3.67117 5.52511 4.15129 5.19845 4.69274 5.02225C5.23419 4.84605 5.81461 4.82758 6.36616 4.96899C6.91772 5.11041 7.41765 5.40587 7.80752 5.82085C8.1974 6.23583 8.46113 6.7532 8.56789 7.3125"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4316 7.3125C15.5384 6.7532 15.8021 6.23583 16.192 5.82085C16.5819 5.40587 17.0818 5.11041 17.6334 4.96899C18.1849 4.82758 18.7653 4.84605 19.3068 5.02225C19.8482 5.19845 20.3284 5.52511 20.6911 5.96404C21.0538 6.40298 21.2841 6.93607 21.355 7.50102C21.426 8.06598 21.3347 8.63947 21.0919 9.15449C20.8491 9.6695 20.4647 10.1048 19.9836 10.4094C19.5026 10.7141 18.9448 10.8756 18.3754 10.875"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconUsersThree;
